import React from "react";
import styles from "./CuteMascotSpinner.module.scss";
import image from "../assets/images/logo/loading.png";

const CuteMascotSpinner = () => {
  return (
    <div className={styles.spinnerContainer}>
      <div className={styles.mascotContainer}>
        <img src={image} alt="Cute Mascot" className={styles.mascot} />
      </div>
      <p className={styles.loadingText}>Loading...</p>
    </div>
  );
};

export default CuteMascotSpinner;
